module.exports = {
    notAllowed: {
        errorTitle: __CONTACT_CENTER__ ? 'contractsView-contractsView_depositRenewalErrorTitleCC' : 'contractsView-contractsView_depositRenewalErrorTitle',
        errorBody: __CONTACT_CENTER__ ? 'contractsView-contractsView_depositRenewalErrorMessageCC' : 'contractsView-contractsView_depositRenewalErrorMessage',
        backButtonLabel: 'contractSummary-backToDeposits',
        backButtonLink: '/myprofile/deposits'
    },
}